import axiosClient from "./ApiInstance";
import toast from "react-hot-toast";
import { clearSession } from "./auth";

// One place decides what an API failure means for the session:
//  - 401 (token missing/expired/invalid) -> end the session and go to login
//  - anything else (network, 4xx validation, 5xx) -> keep the user signed in and
//    hand the server's response body (if any) back to the caller
const handleApiError = (error) => {
  const status = error?.response?.status;
  const isLoginCall = /\/auth\/login\/?$/.test(error?.config?.url || "");

  if (status === 401 && !isLoginCall) {
    clearSession({ expired: true });
    window.location.href = "/";
  } else if (!error?.response) {
    toast.error("Network error. Please check your connection and try again.", {
      id: "network-error",
    });
  }
  console.error(error);
  return error?.response?.data;
};

export const getData = async (url, data) => {
  try {
    const response = await axiosClient.get(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const postData = async (url, data) => {
  try {
    const response = await axiosClient.post(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const putData = async (url, data = {}) => {
  try {
    const response = await axiosClient.put(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const editStatusData = async (url, data = {}) => {
  try {
    const response = await axiosClient.put(
      process.env.REACT_APP_BASE_URL + url,
      data,
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteData = async (url) => {
  try {
    const response = await axiosClient.delete(
      process.env.REACT_APP_BASE_URL + url,
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// Download Apis
export const getDownloadDataExcel = async (aurl, data, name) => {
  try {
    const response = await axiosClient.post(
      process.env.REACT_APP_BASE_URL + aurl,
      data,
      {
        responseType: "blob", // Set responseType to "blob"
      },
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    // Create a temporary anchor element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${name + " " + new Date().toLocaleDateString()}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();

    // Clean up after the download
    window.URL.revokeObjectURL(url);
  } catch (error) {
    return handleApiError(error);
  }
};
